import React, { useEffect, useState } from 'react'
import SoftButton from '@components/common/SoftButton'
import { BellRinging, CoatHanger } from '@phosphor-icons/react'
import ViewSizeGuideModal from '@components/modal/ViewSizeGuideModal'
import TopBottomSizeSelector from './TopBottomSizeSelector'

const SizePanelDynamic = ({productName, sizes, setSize, placeholder='', className = 'mt-2', hasComingSoon, isFreebie = false}) => {
    
    const sortedSizes = sizes?.sort((a, b) => a.position - b.position);

    const isFreeSize = sortedSizes && sortedSizes[0]?.title === "+"
    const [sizeSelected, setSizeSelected] = useState('')
    const [openSizeGuideModal, setOpenSizeGuideModal] = useState(false)
    // const [openNotifyModal, setOpenNotifyModal] = useState(false)

    
    const handleSizeSelected = (size) => {
        setSize(size)
        setSizeSelected(size)
    }

    useEffect(() => {
        // console.log("sorted:",sortedSizes)
        const availableSize = sortedSizes?.find(item => item.availableForSale === true);
        if (availableSize) {
            handleSizeSelected(availableSize);
        }
        
    }, [sortedSizes]);

    
    return (
        <React.Fragment>
            <section className={`${className}`}>
                <div className="flex justify-between items-center">
                    <div className="flex flex-nowrap gap-x-1">
                        {isFreeSize ? <span className="text-sm font-semibold">FREE SIZE</span> : (
                                <>
                                    <span className="text-sm font-semibold">SIZE:</span>
                                    <span className={`text-sm font-normal ${(placeholder != '' && !sizeSelected) && 'text-danger'}`}>{sizeSelected ? sizeSelected?.title : placeholder}</span>
                                </>
                            )
                        }
                    </div>
                    {
                        !isFreeSize && (
                            <div className="flex flex-nowrap items-center gap-x-3">
                                <CoatHanger size={20} weight='light' />
                                <SoftButton
                                    onClick={() => setOpenSizeGuideModal(true)}
                                    label={"VIEW SIZE GUIDE"}
                                    className={`underline underline-offset-2 text-[#4F4F4F] font-normal `}
                                    ariaLabel={'VIEW SIZE GUIDE'}
                                />
                            </div>
                        )
                    }
                </div>
                
                {
                    !isFreeSize && sortedSizes?.length > 7 ? 
                        <TopBottomSizeSelector sortedSizes={sortedSizes} sizeSelected={sizeSelected} handleSizeSelected={handleSizeSelected} />
                    : 
                        <>
                            <div className="flex flex-1 flex-wrap gap-2 mt-3" aria-label='Size Variation container'>
                                {
                                    sortedSizes?.map((item, index) => {
                                        
                                        return (
                                            <div className='flex-1' key={index}>
                                                <button
                                                    key={index}
                                                    //className={`${item?.title === sizeSelected?.title ? 'btn-primary' : 'btn-outline-primary'} relative w-full ${hasComingSoon && '!bg-white !text-gray-400 border !border-gray-400 slash overflow-hidden'} ${(item?.availableForSale === false || isFreebie == true || hasComingSoon) && '!bg-white !text-gray-400 border !border-gray-400 slash overflow-hidden pointer-events-none'}`}
                                                    className={`${item?.title === sizeSelected?.title ? 'btn-primary' : 'btn-outline-primary'} relative w-full ${hasComingSoon && '!bg-white !text-gray-400 border !border-gray-400 slash overflow-hidden'} ${item?.availableForSale === false && '!bg-white !text-gray-400 border !border-gray-400 slash overflow-hidden'}  ${(isFreebie == true || hasComingSoon) && '!bg-white !text-gray-400 border !border-gray-400 slash overflow-hidden pointer-events-none'}`}
                                                    onClick={() => handleSizeSelected(item)}
                                                    aria-label={item?.title}
                                                >
                                                    {item?.title}
                                                </button>
                                                {(item?.availableForSale === false && item?.title === sizeSelected?.title) && (
                                                    <div className='text-gray-400 text-xs pt-1 text-center'>Sold Out</div>
                                                )}
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            
                        </>
            }
            
            </section>
            
            <ViewSizeGuideModal 
                isOpen={openSizeGuideModal}
                hideDefaultButtons={true}
                onClose={() => setOpenSizeGuideModal(false)}
            />
        </React.Fragment>
    );
}

export default SizePanelDynamic